<template>
  <div class='memberAdd'>
    <div class='memberSuccess' v-if="isSuccess">
        <img src="@/assets/img/mine/success.png" class="imgs">
        <p class="txt">添加成功</p>
        <p class="gray">您已将{{parentPhone}}添加为{{loginUser.studentName}}的家长</p>
        <div class="btn-primary" @click="getShare" v-if='!froms'>分享链接给新家长</div>
        <p @click="$router.go(-1)">返回家长列表</p>
    </div> 
    <div class='con' v-else>
        <div class="text" :style="'background:#'+color" v-if="parentId">{{kinshipName.substring(0,1)}}</div>
        <div class="formTxt flex-between" @click="isMaster==1&&channelCode=='esi'?isShow=true:''">
          <label class='font18'>亲属关系</label>
          <p class="flex-between"><span>{{kinshipName||'请选择亲属关系'}}</span>
          <svg-icon icon-class="right" v-if="isMaster==1" /></p>
        </div>
        <div class='formTxt flex-between'>
          <label class='font18'>手机号码</label>
          <span class=" flex-between">
            <template  v-if="isMaster==1&&parentId==''">
                 <span  @click='optInput'>{{parentPhone||'请输入'}}</span>
                 <svg-icon icon-class="right"/>
            </template>
            <template v-else>
                <span>{{parentPhone}}</span>
            </template>
              
          </span>
        </div>
        
        <!-- <van-checkbox v-model="isSynchronization" icon-size=".18rem" class="checkbox" shape="square">将手机号码同步到通讯录保存</van-checkbox> -->
        <div class="btnFixed" v-if="isMaster==1&&channelCode=='esi'"> 
             <div class="wid flex-between" v-if="parentId&&curMaster==0">
                 <div class="btn-reset" @click="delectCon">删除</div>
                 <div class="btn-primary" @click="submit" >保存</div>
             </div>
             <template v-else>
                 <div class="btn-primary" @click="submit" >保存</div>
             </template>
        </div> 
    </div>

    <template v-if="isShare">
       <div class="share" @click="isShare=false">
         <div class="bj"></div>
         <div class="shareTxt">
            <p class="txt">点击右上角进行分享</p>
         </div>
       </div>
    </template>
    
    <van-action-sheet v-model="isShow" cancel-text="取消"
      close-on-click-action
      @cancel="onCancel">
            <div class='addCon'>
               <div class="line flex-center" v-for='(item,i) in options' :key='i' @click="choice(item)">{{item.dictDataName}}</div>
            </div>
    </van-action-sheet>

    <van-popup v-model="isInput" class="textPopup">
        <div class="inputCon">
                <p class="title">手机号码</p>
                <div  class="inputs flex-between">
                    <input v-model="curText" placeholder="" maxlength="11">
                </div>
                <div class='btn'>
                    <p @click="hide">取消</p>
                    <p @click="checkData">确定</p>
                </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
import {updateParentKinship,deleteParentKinship} from "@/api/api.mine";
import {getKinshipList} from "@/api/api.equipment";
import wxapi from '@/utils/wxapi.js';
  export default {
    data() {
      return {
        parentPhone:this.$route.query.parentPhone||'',
        isSynchronization:false,//是否同步
        kinshipCode:this.$route.query.kinshipCode||'',
        kinshipName:this.$route.query.kinshipName||'',
        isMaster:this.$store.state.users.parent.isMaster,
        curMaster:this.$route.query.isMaster||0,
        options:[],
        parentId:this.$route.query.parentId||'',
        color:this.$route.query.color||'',
        isShow:false,
        isSuccess:false,
        isShare:false,
        froms:From,
        channelCode:this.$store.state.loginUser.channelCode,
        isInput:false,
        curText:''
      }
    },
   created(){
     this.getShip();
    },
    methods: {
      submit(){
         if(this.kinshipCode==''&&this.parentPhone==''){
           this.$toast('请完善手机号和亲属关系后再保存');
           return false;
         }else if(this.kinshipCode==''){
           this.$toast('请完善亲属关系后再保存');
           return false;
         }else if(this.parentPhone==''){
           this.$toast('请完善手机号后再保存');
           return false;
         }
         
         let params={
                  isMaster:this.curMaster,
                  studentId:this.loginUser.studentId,
                  isSynchronization:this.isSynchronization?1:0,
                  kinshipCode:this.kinshipCode,
                  kinshipName:this.kinshipName,
                  parentPhone:this.parentPhone,
                  sos:0,
                  parentId:this.parentId
              };
              updateParentKinship(params).then((data) => {
                  if (data && data.result) {
                       if(this.parentId){//编辑
                          this.$toast('保存成功');
                          this.$router.go(-1);
                       }else{//新增家长
                          this.parentPhone=this.parentPhone.replace(this.parentPhone.substring(3,7),'****');
                          this.isSuccess=true;
                          if(this.froms) return false;
                           var url=location.href.split('#')[0];
                          var appid=ENV_API.APP_ID;
                          wxapi.wxRegister(appid,url);
                       }
                  }else{
                    this.$toast(data.message);
                  }
              })
       },
       delectCon(){
         this.$dialog.confirm({
            title:'删除家长',
            message: '确定删除该家庭成员吗',
            confirmButtonColor:'#E84026',
            confirmButtonText:'删除',
            cancelButtonColor:'#0A59F7',
         }).then(() => {
              deleteParentKinship({
                  parentId:this.parentId
              }).then((data) => {
                if (data && data.result) {
                   this.$toast('删除成功');
                   this.$router.go(-1);
                }else{
                  this.$toast(data.message);
                }
              })
         }).catch(() => {
          // on cancel
         });
       },
       optInput(){
            this.isInput=true;
            this.curText=this.parentPhone;
       },
       hide(){
        this.isInput=false;
       },
       //手机号验证
       checkData(){
         let str=this.pubMethod.checkPhone(this.curText);
         if(this.curText&&!str){
            this.$toast('请输入正确手机号码');
         }else{
          this.parentPhone=this.curText;
          this.hide();
         }
        
       },
       getShare(){
         this.isShare=true;
         let option={
                  myValue:'在鸿学生终端',
                  title:'我已添加你为'+this.loginUser.studentName+'的家长，快点击这里进去体验吧!',
                  imgs:ENV_API.API_HOST+'/app/static/shareLogo.png',
                  link:ENV_API.API_HOST+'/app/#/memberSuccess',
                  success: () => {
                    // this.isShare=false;
                  }
                }
          wxapi.shareAppMessage(option);
         
       },
       
       getShip(){
         getKinshipList({type:1}).then(data=>{
          
           this.options=data.result;
         })
       },
       choice(item){
         this.kinshipCode=item.dictDataCode;
         this.kinshipName=item.dictDataName;
         this.onCancel();
       },
       onCancel(){
        this.isShow=false;
      }
    },
  }
</script>
<style lang="scss" >
.memberAdd{
  padding:.15rem;
  font-size: .16rem;
  .memberSuccess{
    text-align: center;
    padding-top: .62rem;
    .imgs{
      margin-bottom: .15rem;
    }
    .txt{
      font-size: .16rem;
      margin-bottom: .1rem;
    }
    .btn-primary{
      margin-top: .9rem;
      margin-bottom: .2rem;
    }
  }
  .con{
      position: relative;
      .text{
        width:.8rem;
        height:.8rem;
        border-radius:50%;
        margin: .4rem auto;
        line-height: .8rem;
        font-size: .32rem;
        text-align: center;
        color: #fff;
        background: #B7C5D2;
        vertical-align: middle;
      }
      .formTxt{
        background:#fff;
        padding:0rem .12rem;
        border-radius: 8px;
        margin-bottom: .12rem;
        line-height: .48rem;
        color: #666;
        label{
          color:rgba(0,0,0,.9);
        }
      }
      .checkbox{
        margin-top: .1rem;
      }
  }
  .share{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    .bj{
      background: #000;
      opacity: .7;
      height: 100%;
      width: 100%;
    }
    .shareTxt{
      background:url(../../../assets/img/mine/shareBack.png) no-repeat right top;
      position: absolute;
      top: 5px;
      right: 5px;
      padding: 110px 30px 0px 0px;
      color: #fff;
      background-size: 70px;
    }
  }
  
  .van-button--square{
        height: 100%;
  }
  .line{
    line-height: .3rem;
  }
  .wid div:last-child{
    margin-left: .12rem;
  } 
}

</style>